import type {
  IMediaLibDialogItem,
  MediaLibPresetEnum,
  TElement,
} from "@editor/modules/media-lib/types";
import type { IMediaFile } from "@/shared/types";
import { MediaLibFiles } from "../../files";
import { useMediaLibPanelStoreShallow } from "../stores";

interface IProps {
  onSelect?: (item: IMediaFile) => void;
  selectedItems?: IMediaLibDialogItem[];
  isMultiSelect?: boolean;
  view?: "panel" | "dialog";
  preset?: MediaLibPresetEnum;
  source?: "default" | "settings";
  bulkUpdateFiles?: (ids: string[], data: Partial<IMediaFile>) => void;
  elementWrapper?: React.ComponentType<{
    children: React.ReactNode;
    element: TElement;
  }>;
}

export const MediaLibPanelFiles = ({
  onSelect,
  selectedItems,
  isMultiSelect,
  view,
  preset,
  source,
  elementWrapper,
}: IProps) => {
  const {
    files,
    selectedFolderId,
    category,
    hasSearch,
    updateFile,
    removeFile,
  } = useMediaLibPanelStoreShallow((s) => ({
    hasSearch: s.searchQuery.length > 0,
    files: s.files,
    selectedFolderId: s.selectedFolderId,
    category: s.category,
    updateFile: s.updateFile,
    removeFile: s.removeFile,
  }));

  return (
    <div className="tw-mt-3 tw-grid tw-w-[calc(100%-4px)]">
      <MediaLibFiles
        files={files}
        category={category}
        selectedFolderId={selectedFolderId}
        hasSearch={hasSearch}
        updateFile={updateFile}
        removeFile={removeFile}
        onSelect={onSelect}
        selectedItems={selectedItems}
        isMultiSelect={isMultiSelect}
        view={view}
        mediaPreset={preset}
        source={source}
        elementWrapper={elementWrapper}
      />
    </div>
  );
};
